/**
 * SAIT-135: необязательная подписка в заявке; выбор сохраняется при перерисовке.
 * По умолчанию не отмечена: согласие на рекламу должен дать сам человек (38-ФЗ «О рекламе», ст. 18).
 */
import './newsletter-checkbox.css';

let sequence = 0;

export const NewsletterCheckbox = {
    data() {
        return { checked: false, inputId: 'tnl-consent-' + ++sequence };
    },
    template: `
        <div class="checkbox tnl-consent">
            <input v-model="checked" :id="inputId" type="checkbox" name="TAS_NEWSLETTER_CONSENT"
                value="Y" class="checkbox__input">
            <label :for="inputId" class="checkbox__label">
                Получать новости и акции по email.
                <a href="/soglasie-na-rassylku/" target="_blank" rel="noopener">Согласие на рассылку</a>
            </label>
        </div>
    `,
};
